// Autorizacao do modulo de atendimento no front. O CASL instalado no
// template (@casl/vue) esta morto - falta o @casl/ability e nunca foi
// ligado no bootstrap (ver auditoria da Fase 3) - peso morto que nao vale
// religar so pra isso. Mapa simples baseado em users.perfil (string nova:
// admin/supervisor/operador, distinta do access_nivel numerico legado).

export const PERFIS = {
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  OPERADOR: 'operador',
}

// Recurso nao listado aqui = liberado para qualquer perfil autenticado
// (mantém os CRUDs legados de Dispositivos/Unidades/Grupos funcionando
// sem precisar mapear cada um).
const PERMISSOES = {
  atendimento: [PERFIS.ADMIN, PERFIS.SUPERVISOR, PERFIS.OPERADOR],
  atendimento_atribuir: [PERFIS.ADMIN, PERFIS.SUPERVISOR],
  atendimento_reabrir: [PERFIS.ADMIN, PERFIS.SUPERVISOR],
  atendimento_devolver_fluxo: [PERFIS.ADMIN, PERFIS.SUPERVISOR],
  departamentos: [PERFIS.ADMIN, PERFIS.SUPERVISOR],
  fluxos: [PERFIS.ADMIN, PERFIS.SUPERVISOR],
  modelos_mensagem: [PERFIS.ADMIN, PERFIS.SUPERVISOR],
}

export function podeAcessar(perfil, recurso) {
  if (!PERMISSOES[recurso]) {
    return true
  }
  return PERMISSOES[recurso].includes(perfil)
}

export default function instalarPermissoes(Vue, store) {
  Vue.prototype.$can = function (recurso) {
    return podeAcessar(store.state.user.perfil, recurso)
  }
}
